import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  selectedModule: string = '';
  uploadFile: File | null = null;
  uploadProgress: number = 0;
  isUploading: boolean = false;
  uploadResult: any = null;
  currentUser: any;

  modules = [
    { id: 'customer', name: 'Customer Details', table: 'customer_details' },
    { id: 'employee', name: 'Employee Details', table: 'employee' },
    { id: 'inventory', name: 'Inventory Products', table: 'inventory_manager' },
    { id: 'service', name: 'Service Offered', table: 'service_offered' }
  ];

  templateColumns = {
    customer: ['cus_name', 'cus_mobile', 'cus_email', 'cus_address', 'cus_dob', 'cus_gender'],
    employee: ['emp_name', 'emp_mobile', 'emp_email', 'emp_address', 'emp_dob', 'emp_gender', 'emp_designation'],
    inventory: ['short_desc', 'brand', 'amt_per', 'quantity_on_hand', 'gst_value', 'balance_percent'],
    service: ['service_category_id', 'service_list_id', 'inventory_manager_id', 'type', 'start_date', 'end_date', 'coupon_code']
  };

  constructor(
    private loginService: LoginService,
    private router: Router
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginService.getLocalSession('currentUser'));
    if (!this.currentUser.uid) {
      this.router.navigate(['/login']);
    }
  }

  downloadTemplate() {
    if (!this.selectedModule) {
      alert('Please select a module first');
      return;
    }

    const columns = this.templateColumns[this.selectedModule];
    const templateData = [columns];

    const ws = XLSX.utils.aoa_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Template');

    const fileName = `${this.selectedModule}_template.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.uploadFile = file;
    } else {
      alert('Please select a valid Excel file (.xlsx)');
      event.target.value = '';
    }
  }

  uploadData() {
    if (!this.selectedModule || !this.uploadFile) {
      alert('Please select module and file');
      return;
    }

    this.isUploading = true;
    this.uploadProgress = 0;

    const formData = new FormData();
    formData.append('file', this.uploadFile);
    formData.append('module', this.selectedModule);
    formData.append('user_id', this.currentUser.uid);

    this.loginService.uploadBulkData(formData).subscribe(
      (response: any) => {
        this.uploadProgress = 100;
        this.isUploading = false;
        this.uploadResult = response;
        if (response.status === 1) {
          alert(`Upload successful! ${response.inserted} records inserted, ${response.failed} failed.`);
        } else {
          alert('Upload failed: ' + response.message);
        }
      },
      (error) => {
        // alert('Network Error uploadBulkData API');
        this.isUploading = false;
        this.uploadProgress = 0;
        alert('Upload failed: ' + error.message);
      }
    );
  }

  resetUpload() {
    this.selectedModule = '';
    this.uploadFile = null;
    this.uploadProgress = 0;
    this.uploadResult = null;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/upload/upload.component.ts